module.exports = __webpack_public_path__ + "assets/img/appointment-head-back.101e6f39.png";